import { GenericSimpleDataProvider } from 'src/app/model/internal';
import { GroupTiming } from 'src/app/model/server';
import { VideoServerRestService } from 'src/app/services/rest/video-server-rest.service';
import { SearchingContextService } from 'src/app/services/searching-context.service';
import { Observable } from 'rxjs';

export class SearchingTerms {
    constructor(public month: number, public duration: number) { }
  }

export class ReportDataProvider implements GenericSimpleDataProvider<GroupTiming[]> {
constructor(
            private searchContextPath: string,
            private schoolId: number,
            private rest: VideoServerRestService,
            private terms: SearchingTerms,
            private searchingContext: SearchingContextService
            ) {}
    doLoad(): Observable<GroupTiming[]> {
        this.searchingContext.updateContext<SearchingTerms>(this.searchContextPath, this.terms);
        return this.rest.getBillingReport(this.schoolId, this.terms.month, this.terms.duration);
    }
}
